import React from 'react'
import HomeDashboardContainers from './HomeDashboardContainers'

const HomeDashboard = () => (
  <HomeDashboardContainers />
)

export default HomeDashboard
